import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";

function BusinessHours({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setsuccess] = useState("");
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [loadingButton, setLoadingButton] = useState(false);

  const [businessHours, setBusinessHours] = useState([]);

  // Initialize business hours from formData or default values
  useEffect(() => {
    if (formData.business_hours && formData.business_hours.length > 0) {
      // Map the formData.business_hours to match the state structure
      const initializedHours = days.map((day) => {
        const existingDay = formData.business_hours.find((bh) => bh.day === day);
        return {
          day,
          start_time: existingDay?.start_time || "",
          end_time: existingDay?.end_time || "",
        };
      });
      setBusinessHours(initializedHours);
    } else {
      // Initialize with default empty values
      setBusinessHours(days.map((day) => ({ day, start_time: "", end_time: "" })));
    }
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);

    const payload = {
      _id: formData.id,
      business_hours: businessHours,
    };
    console.log(payload, "payload");
    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      setLoadingButton(false);
      toast.success("Hours updated Successfully");
    } else {
      toast.error("Error updating Data");
      setLoadingButton(false);
    }
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    setBusinessHours((prevData) =>
      prevData.map((entry, i) => (i === index ? { ...entry, [name]: value } : entry))
    );
    setsuccess("");
  };

  return (
    <div>
      <p className="text-center">{success}</p>

      <form onSubmit={handleSubmit}>
        {businessHours.map((entry, index) => (
          <div style={{ display: "flex", width: "100%" }} key={index}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Day</label>
                <input
                  className="form-control-agust"
                  value={entry.day}
                  readOnly
                  style={{ backgroundColor: "#f5f5f5" }}
                />
              </SoftBox>
            </div>
            <div style={{ width: "25%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Start Time</label>
                <input
                  className="form-control-agust"
                  onChange={(e) => handleChange(e, index)}
                  placeholder="Start Time"
                  name="start_time"
                  type="time"
                  value={entry.start_time}
                />
              </SoftBox>
            </div>
            <div style={{ width: "25%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">End Time</label>
                <input
                  className="form-control-agust"
                  onChange={(e) => handleChange(e, index)}
                  placeholder="End Time"
                  name="end_time"
                  type="time"
                  value={entry.end_time}
                />
              </SoftBox>
            </div>
          </div>
        ))}

        <div style={{ margin: "10px 0px", textAlign: "right" }}>
          <SoftButton
            type="submit"
            style={{ color: "white", background: "black", padding: "5px 10px" }}
            className="px-2 py-2"
            disabled={loadingButton}
          >
            {loadingButton ? "Loading..." : "Update Business Hours"}
          </SoftButton>
        </div>
      </form>
    </div>
  );
}

export default BusinessHours;
